(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toss-homepage-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.toss-header').forEach(function (header) {
    // Solid-on-scroll for the transparent variant
    if (header.dataset.transparent === 'true') {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });

  // Search-as-you-type: debounced predictive search into a combobox dropdown.
  // Enter still submits the plain form to the full results page.
  document.querySelectorAll('[data-toss-suggest]').forEach(function (box) {
    var input = box.querySelector('[data-toss-suggest-input]');
    var panel = box.querySelector('[data-toss-suggest-panel]');
    if (!input || !panel) return;
    var controller = null;
    var timer = null;
    var activeIndex = -1;

    function setExpanded(open) {
      panel.hidden = !open;
      input.setAttribute('aria-expanded', String(open));
      if (!open) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
      }
    }

    function options() {
      return panel.querySelectorAll('[role="option"]');
    }

    function setActive(i) {
      var opts = options();
      if (!opts.length) return;
      activeIndex = (i + opts.length) % opts.length;
      opts.forEach(function (o, idx) {
        o.classList.toggle('is-active', idx === activeIndex);
        o.setAttribute('aria-selected', String(idx === activeIndex));
      });
      input.setAttribute('aria-activedescendant', opts[activeIndex].id);
      opts[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function thumb(url) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=88';
    }

    function render(products, query) {
      panel.textContent = '';
      var symbol = box.dataset.currencySymbol || '£';
      if (!products.length) {
        var empty = document.createElement('p');
        empty.className = 'toss-header__sg-empty';
        empty.textContent = 'No quick matches for “' + query + '”. Press Enter to search the whole shop.';
        panel.appendChild(empty);
      }
      products.forEach(function (p, i) {
        var a = document.createElement('a');
        a.className = 'toss-header__sg-item';
        a.href = p.url;
        a.id = panel.id + '-opt-' + i;
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        var img = document.createElement('img');
        img.alt = '';
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';
        if (p.featured_image && p.featured_image.url) img.src = thumb(p.featured_image.url);
        a.appendChild(img);
        var name = document.createElement('span');
        name.className = 'toss-header__sg-name';
        name.textContent = p.title;
        a.appendChild(name);
        var price = document.createElement('span');
        price.className = 'toss-header__sg-price';
        price.textContent = symbol + p.price;
        a.appendChild(price);
        panel.appendChild(a);
      });
      var all = document.createElement('a');
      all.className = 'toss-header__sg-all';
      all.href = box.dataset.searchUrl + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
      all.textContent = 'See all results for “' + query + '”';
      panel.appendChild(all);
      setExpanded(true);
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var u = box.dataset.suggestUrl + '.json' +
        '?q=' + encodeURIComponent(query) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bprefix%5D=last';
      fetch(u, { signal: controller.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, input.value.trim());
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') setExpanded(false);
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(timer);
      if (query.length < 2) {
        setExpanded(false);
        return;
      }
      timer = setTimeout(function () { search(query); }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !panel.hidden) {
        e.preventDefault();
        setActive(activeIndex + 1);
      } else if (e.key === 'ArrowUp' && !panel.hidden) {
        e.preventDefault();
        setActive(activeIndex - 1);
      } else if (e.key === 'Enter') {
        var opts = options();
        if (!panel.hidden && activeIndex > -1 && opts[activeIndex]) {
          e.preventDefault();
          window.location.href = opts[activeIndex].href;
        }
      } else if (e.key === 'Escape') {
        setExpanded(false);
      }
    });

    input.addEventListener('focus', function () {
      if (panel.childElementCount && input.value.trim().length >= 2) setExpanded(true);
    });

    document.addEventListener('click', function (e) {
      if (!box.contains(e.target)) setExpanded(false);
    });
  });

  // Mobile menu open/close
  var mmenu = document.querySelector('[data-toss-mmenu]');
  if (mmenu) {
    var setOpen = function (open) {
      mmenu.classList.toggle('is-open', open);
      mmenu.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      document.querySelectorAll('[data-toss-menu-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', String(open));
      });
    };
    document.querySelectorAll('[data-toss-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(true); });
    });
    mmenu.querySelectorAll('[data-toss-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toss-homepage-offer-ticket"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-toss-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.end.replace(' ', 'T'));
    if (isNaN(end.getTime())) return;
    var fields = {
      d: el.querySelector('[data-cd="d"]'),
      h: el.querySelector('[data-cd="h"]'),
      m: el.querySelector('[data-cd="m"]'),
      s: el.querySelector('[data-cd="s"]')
    };
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        diff = 0;
        if (el.dataset.hideExpired === 'true') el.classList.add('is-expired-hidden');
        clearInterval(timer);
      }
      var s = Math.floor(diff / 1000);
      fields.d.textContent = pad(Math.floor(s / 86400));
      fields.h.textContent = pad(Math.floor((s % 86400) / 3600));
      fields.m.textContent = pad(Math.floor((s % 3600) / 60));
      fields.s.textContent = pad(s % 60);
    };
    var timer = setInterval(tick, 1000);
    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toss-pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.toss-pdp').forEach(function (root) {
      var variants = [];
      try { variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent); } catch (e) {}
      var sizeIdx = parseInt(root.dataset.sizeIdx, 10);     /* 1-based option position, 0 = none */
      var currency = root.dataset.currency || 'GBP';
      var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency });
      var money = function (cents) { return fmt.format(cents / 100); };

      /* ── Gallery: thumbs + inline hover zoom ── */
      var main = root.querySelector('[data-pdp-main]');
      var ZOOM = 2.3;
      if (main) {
        main.addEventListener('mousemove', function (e) {
          var img = main.querySelector('img');
          if (!img) return;
          var r = main.getBoundingClientRect();
          img.style.transformOrigin =
            ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
          img.style.transform = 'scale(' + ZOOM + ')';
          main.classList.add('is-zooming');
        });
        main.addEventListener('mouseleave', function () {
          var img = main.querySelector('img');
          if (img) { img.style.transform = ''; img.style.transformOrigin = 'center'; }
          main.classList.remove('is-zooming');
        });
      }
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      var counter = root.querySelector('[data-pdp-counter]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          t.setAttribute('aria-pressed', 'true');
          var img = main && main.querySelector('img');
          if (img) { img.src = t.dataset.full; img.srcset = ''; img.alt = t.dataset.alt || ''; }
          if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
          t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });

      /* ── Option state ── */
      var optEls = root.querySelectorAll('[data-pdp-opt]');
      var state = {};
      optEls.forEach(function (el) {
        var pos = el.dataset.pdpOpt;
        if (el.tagName === 'SELECT') {
          state[pos] = el.value;
        } else {
          var pressed = el.querySelector('[aria-pressed="true"]');
          state[pos] = pressed ? pressed.dataset.pdpVal : null;
        }
      });

      function findVariant() {
        return variants.find(function (v) {
          return Object.keys(state).every(function (pos) {
            return state[pos] === null || v.options[pos - 1] === state[pos];
          });
        });
      }

      function exactVariant() {
        return variants.find(function (v) {
          return Object.keys(state).every(function (pos) { return v.options[pos - 1] === state[pos]; });
        });
      }

      function refresh() {
        /* strike sizes unavailable for the current colour/other options */
        var sizes = root.querySelector('[data-pdp-sizes]');
        if (sizes) {
          sizes.querySelectorAll('button').forEach(function (b) {
            var ok = variants.some(function (v) {
              if (!v.available) return false;
              if (v.options[sizeIdx - 1] !== b.dataset.pdpVal) return false;
              return Object.keys(state).every(function (pos) {
                if (parseInt(pos, 10) === sizeIdx) return true;
                return state[pos] === null || v.options[pos - 1] === state[pos];
              });
            });
            b.disabled = !ok;
            if (!ok && b.getAttribute('aria-pressed') === 'true') {
              b.setAttribute('aria-pressed', 'false');
              state[sizeIdx] = null;
            }
          });
        }

        syncReady();

        /* price + hidden id from the closest matching variant */
        var v = exactVariant() || findVariant();
        if (!v) return;
        var idInput = root.querySelector('[data-pdp-id]');
        if (idInput && String(idInput.value) !== String(v.id)) {
          idInput.value = v.id;
          /* lets the wallet buttons pick up the new variant */
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var now = money(v.price);
        var hasDeal = v.compare_at_price && v.compare_at_price > v.price;
        ['', '-m'].forEach(function (sfx) {
          var nowEl = root.querySelector('[data-pdp-now' + sfx + ']');
          var wasEl = root.querySelector('[data-pdp-was' + sfx + ']');
          if (nowEl) nowEl.textContent = now;
          if (wasEl) {
            wasEl.hidden = !hasDeal;
            if (hasDeal) wasEl.textContent = money(v.compare_at_price);
          }
        });
        var save = root.querySelector('[data-pdp-save]');
        if (save) {
          save.hidden = !hasDeal;
          if (hasDeal) {
            var diff = v.compare_at_price - v.price;
            save.textContent = 'Save ' + money(diff).replace(/\.00$/, '') + ' · ' + Math.round((diff / v.compare_at_price) * 100) + '%';
          }
        }
      }

      /* ── Option clicks ── */
      optEls.forEach(function (el) {
        var pos = el.dataset.pdpOpt;
        if (el.tagName === 'SELECT') {
          el.addEventListener('change', function () { state[pos] = el.value; refresh(); });
        } else {
          el.querySelectorAll('button').forEach(function (b) {
            b.addEventListener('click', function () {
              el.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
              b.setAttribute('aria-pressed', 'true');
              state[pos] = b.dataset.pdpVal;
              if (parseInt(pos, 10) !== sizeIdx) {
                var nameEl = root.querySelector('[data-pdp-colour-name]');
                if (nameEl) nameEl.textContent = b.dataset.pdpVal;
              } else {
                var labels = root.querySelectorAll('[data-pdp-add-label]');
                labels.forEach(function (l) { l.textContent = 'Add to basket: ' + b.dataset.pdpVal; });
              }
              refresh();
            });
          });
        }
      });

      /* ── Add to basket needs a size ── */
      var form = root.querySelector('.toss-pdp__form');
      function missingOpts() {
        return Array.prototype.filter.call(optEls, function (el) {
          var v = state[el.dataset.pdpOpt];
          return v === null || v === undefined;
        });
      }
      function sizeChosen() { return missingOpts().length === 0; }
      function nudgeSizes() {
        var missing = missingOpts();
        missing.forEach(function (el) {
          el.classList.remove('is-attention');
          void el.offsetWidth;
          el.classList.add('is-attention');
        });
        if (missing[0]) {
          window.scrollTo({ top: missing[0].getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        }
      }
      /* Add + wallet buttons look blanked out until every option is chosen (still clickable, to prompt) */
      function syncReady() {
        var incomplete = !sizeChosen();
        root.querySelectorAll('[data-pdp-add], [data-pdp-add-m], [data-pdp-express]').forEach(function (el) {
          el.classList.toggle('is-incomplete', incomplete);
          if (el.tagName === 'BUTTON') el.setAttribute('aria-disabled', incomplete ? 'true' : 'false');
        });
      }
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!sizeChosen()) { e.preventDefault(); nudgeSizes(); }
        });
      }
      var mAdd = root.querySelector('[data-pdp-add-m]');
      if (mAdd && form) {
        mAdd.addEventListener('click', function () {
          if (!sizeChosen()) { nudgeSizes(); return; }
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      /* ── Wallet buttons also need a size (otherwise they buy the default variant) ── */
      var express = root.querySelector('[data-pdp-express]');
      if (express) {
        ['click', 'pointerdown'].forEach(function (type) {
          express.addEventListener(type, function (e) {
            if (sizeChosen()) return;
            e.preventDefault();
            e.stopPropagation();
            if (type === 'click') nudgeSizes();
          }, true);
        });
      }

      /* ── Hide the sticky bar while the in-flow buttons are on screen ── */
      var stickyBar = root.querySelector('.toss-pdp__mobile-add');
      var inFlowAdd = root.querySelector('.toss-pdp__add');
      if (stickyBar && inFlowAdd && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          stickyBar.classList.toggle('is-covered', entries[0].isIntersecting);
        }).observe(express || inFlowAdd);
      }

      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toss-pdp-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.toss-pdpr').forEach(function (root) {
      var url = root.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-pdpr-grid]');
          var grid = root.querySelector('[data-pdpr-grid]');
          if (fresh && grid && fresh.children.length > 0) grid.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* fallback content already rendered */ });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toss-plp-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.toss-plpg').forEach(function (root) {
      var KEY = 'toss:plp:pp-mult';
      var pp = parseInt(root.dataset.pp, 10);
      var controller = null;
      var countCtrl = null;
      var countTimer = null;
      var slowTimer = null;

      function q(sel) { return root.querySelector(sel); }

      /* ── Mobile drawer ── */
      function setDrawer(open) {
        var filters = q('[data-plpg-filters]');
        var scrim = q('[data-plpg-scrim]');
        if (!filters) return;
        filters.classList.toggle('is-open', open);
        if (scrim) scrim.classList.toggle('is-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      }

      /* Current filter selections as a URL on the collection path */
      function filterUrl() {
        var u = new URL(window.location.pathname, window.location.origin);
        var filters = q('[data-plpg-filters]');
        if (filters) {
          new FormData(filters).forEach(function (value, key) {
            if (value !== '') u.searchParams.append(key, value);
          });
        }
        return u;
      }

      function savedMult() {
        var saved = 1;
        try { saved = parseInt(localStorage.getItem(KEY) || '1', 10) || 1; } catch (e) {}
        return saved;
      }

      /* Filter groups are <details> rebuilt from scratch on every refresh, so
         their open/closed state is read off the live panel and written onto
         the incoming markup before it is swapped in. Keyed by group name;
         a group the shopper has not seen yet keeps the server's default. */
      function openGroups(scope) {
        var state = Object.create(null);
        scope.querySelectorAll('.toss-plpg__fgroup').forEach(function (d) {
          var name = d.querySelector('.toss-plpg__fg-name');
          if (name) state[name.textContent.trim()] = d.open;
        });
        return state;
      }

      function restoreGroups(scope, state) {
        scope.querySelectorAll('.toss-plpg__fgroup').forEach(function (d) {
          var name = d.querySelector('.toss-plpg__fg-name');
          if (!name) return;
          var was = state[name.textContent.trim()];
          if (was === undefined) return;
          if (was) { d.setAttribute('open', ''); } else { d.removeAttribute('open'); }
        });
      }

      /* Values the applied filters rule out are disabled by the server. That
         is right on desktop, where a change applies immediately, but wrong in
         the drawer, where the shopper is composing a selection and may be
         about to drop the filter that ruled them out. `.is-out` stays on as
         the record, so the lock comes back when the viewport does. */
      var drawerMq = window.matchMedia('(max-width: 920px)');

      function unlockOutValues(scope) {
        var filters = scope.querySelector('[data-plpg-filters]') ||
          (scope.matches && scope.matches('[data-plpg-filters]') ? scope : null);
        if (!filters) return;
        var locked = !drawerMq.matches;
        filters.querySelectorAll('.is-out input').forEach(function (input) {
          input.disabled = locked;
        });
      }

      /* ── Pending filter state (drawer) ──
             Below 920px the drawer stages choices and only applies them on
             Show, so every counter in it has to be read off the form rather
             than off the applied URL, or it reports the previous state. */

      /* Choices staged in one filter group: checked boxes, or a filled-in
         price field either side. */
      function groupCount(group) {
        if (group.querySelector('.toss-plpg__fprice')) {
          var filled = 0;
          group.querySelectorAll('.toss-plpg__fprice input').forEach(function (i) {
            if (i.value !== '') filled = 1;
          });
          return filled;
        }
        return group.querySelectorAll('input[type="checkbox"]:checked').length;
      }

      function syncPending() {
        var filters = q('[data-plpg-filters]');
        if (!filters) return 0;
        var total = 0;
        filters.querySelectorAll('.toss-plpg__fgroup').forEach(function (group) {
          var n = groupCount(group);
          total += n;
          var sum = group.querySelector('[data-plpg-fsum]');
          if (sum) {
            sum.textContent = n + ' selected';
            sum.hidden = n === 0;
          }
        });
        var badge = q('[data-plpg-fopen-n]');
        if (badge) { badge.textContent = total; badge.hidden = total === 0; }
        var clear = q('[data-plpg-clear]');
        if (clear) clear.hidden = total === 0;
        return total;
      }

      /* ── Live result count on the Show button ──
             Counting is a server job (facets across groups can't be
             intersected client-side), so it goes to the count-only
             collection view: a bare integer, no layout, no grid markup.
             Debounced and abortable, so a burst of taps costs one request. */
      function setApply(label, disabled, busy) {
        var apply = q('[data-plpg-apply]');
        if (!apply) return;
        apply.textContent = label;
        apply.disabled = !!disabled;
        apply.setAttribute('aria-disabled', String(!!disabled));
        apply.setAttribute('aria-busy', String(!!busy));
      }

      function countStyles() {
        if (countTimer) clearTimeout(countTimer);
        if (slowTimer) clearTimeout(slowTimer);
        var apply = q('[data-plpg-apply]');
        if (apply) apply.setAttribute('aria-busy', 'true');
        /* Only say "Counting" if the answer is slow enough to be worth
           saying, so a quick reply doesn't flash the label. */
        slowTimer = setTimeout(function () { setApply('Counting styles', true, true); }, 180);

        countTimer = setTimeout(function () {
          if (countCtrl) countCtrl.abort();
          countCtrl = new AbortController();
          var u = filterUrl();
          u.searchParams.delete('page');
          u.searchParams.set('view', 'toss-count');
          fetch(u.toString(), { signal: countCtrl.signal })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.text();
            })
            .then(function (text) {
              var n = parseInt(text.trim(), 10);
              clearTimeout(slowTimer);
              if (isNaN(n)) { setApply('Show styles', false, false); return; }
              if (n === 0) { setApply('No styles match', true, false); return; }
              setApply('Show ' + n + (n === 1 ? ' style' : ' styles'), false, false);
            })
            .catch(function (err) {
              if (err.name === 'AbortError') return;
              /* Never trap the shopper behind a count we couldn't fetch. */
              clearTimeout(slowTimer);
              setApply('Show styles', false, false);
            });
        }, 250);
      }

      /* ── AJAX refresh via the Section Rendering API - no reload, no scroll jump ── */
      function refresh(url, push, scrollToTop) {
        if (controller) controller.abort();
        controller = new AbortController();
        /* The response carries the applied counts, so a pending count landing
           after it would put a stale number back on the button. */
        if (countCtrl) countCtrl.abort();
        if (countTimer) clearTimeout(countTimer);
        if (slowTimer) clearTimeout(slowTimer);
        var u = new URL(url, window.location.origin);
        u.searchParams.delete('section_id');
        var clean = u.toString();
        u.searchParams.set('section_id', root.dataset.sectionId);
        root.setAttribute('aria-busy', 'true');
        fetch(u.toString(), { signal: controller.signal })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.toss-plpg');
            var wrap = q('.toss-plpg__wrap');
            var freshWrap = fresh && fresh.querySelector('.toss-plpg__wrap');
            if (!wrap || !freshWrap) { window.location.href = clean; return; }
            restoreGroups(freshWrap, openGroups(wrap));
            unlockOutValues(freshWrap);
            wrap.replaceWith(freshWrap);
            root.dataset.page = fresh.dataset.page;
            root.dataset.pages = fresh.dataset.pages;
            if (push) history.pushState({ tossPlpg: true }, '', clean);
            document.body.style.overflow = '';
            root.setAttribute('aria-busy', 'false');
            if (scrollToTop) {
              var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              root.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
            }
            announceCount();
            var saved = savedMult();
            if (saved > 1) applyMult(saved, true);
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            root.setAttribute('aria-busy', 'false');
            window.location.href = clean;
          });
      }

      function announceCount() {
        var live = q('[data-plpg-live]');
        var count = q('.toss-plpg__tcount');
        if (live && count) live.textContent = count.textContent;
      }

      /* ── Per-page (Show 24 / 48 / 72) ── */
      function applyMult(mult, fromLoad) {
        var perpage = q('[data-plpg-perpage]');
        var grid = q('[data-plpg-grid]');
        var pager = q('[data-plpg-pager]');
        if (perpage) {
          perpage.querySelectorAll('[data-plpg-pp]').forEach(function (o) {
            o.setAttribute('aria-pressed', String(parseInt(o.dataset.plpgPp, 10) === mult));
          });
          var val = perpage.querySelector('[data-plpg-ppval]');
          if (val) val.textContent = pp * mult;
        }
        if (mult > 1 && grid && root.dataset.page === '1') {
          var pages = parseInt(root.dataset.pages, 10);
          var fetches = [];
          for (var i = 2; i <= Math.min(mult, pages); i++) {
            var u = new URL(window.location.href);
            u.searchParams.set('page', i);
            u.searchParams.set('section_id', root.dataset.sectionId);
            fetches.push(fetch(u.toString()).then(function (r) { return r.text(); }));
          }
          Promise.all(fetches).then(function (htmls) {
            htmls.forEach(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var g = doc.querySelector('[data-plpg-grid]');
              if (g) Array.prototype.slice.call(g.children).forEach(function (el) { grid.appendChild(el); });
            });
            if (pager && pages <= mult) pager.style.display = 'none';
          });
        }
        if (!fromLoad && mult === 1) refresh(window.location.href, false);
      }

      function closePerPage() {
        var perpage = q('[data-plpg-perpage]');
        if (!perpage) return;
        var pop = perpage.querySelector('[data-plpg-pppop]');
        var btn = perpage.querySelector('[data-plpg-ppbtn]');
        if (pop) pop.hidden = true;
        perpage.classList.remove('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }

      /* ── Delegated events: listeners live on the root, so they
             survive the wrap being swapped out by refresh() ── */
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-plpg-open]')) { setDrawer(true); return; }
        if (e.target.closest('[data-plpg-close]')) { setDrawer(false); return; }
        if (e.target.closest('[data-plpg-scrim]')) { setDrawer(false); return; }

        var ppBtn = e.target.closest('[data-plpg-ppbtn]');
        if (ppBtn) {
          var perpage = ppBtn.closest('[data-plpg-perpage]');
          var pop = perpage.querySelector('[data-plpg-pppop]');
          var open = pop.hidden;
          pop.hidden = !open;
          perpage.classList.toggle('is-open', open);
          ppBtn.setAttribute('aria-expanded', String(open));
          return;
        }

        var ppOpt = e.target.closest('[data-plpg-pp]');
        if (ppOpt) {
          var mult = parseInt(ppOpt.dataset.plpgPp, 10);
          try { localStorage.setItem(KEY, String(mult)); } catch (err) {}
          closePerPage();
          applyMult(mult, false);
          return;
        }

        var pageLink = e.target.closest('[data-plpg-pager] a');
        if (pageLink) {
          e.preventDefault();
          refresh(pageLink.href, true, true);
          return;
        }

        var clear = e.target.closest('.toss-plpg__f-clear');
        if (clear) {
          e.preventDefault();
          setDrawer(false);
          refresh(clear.href, true);
        }
      });

      root.addEventListener('change', function (e) {
        if (e.target.closest('[data-plpg-sort]')) {
          var u = filterUrl();
          u.searchParams.set('sort_by', e.target.value);
          u.searchParams.delete('page');
          refresh(u.toString(), true);
          return;
        }
        /* Filters auto-apply on change (desktop); drawer waits for Apply */
        if (e.target.closest('[data-plpg-filters]')) {
          syncPending();
          if (window.matchMedia('(max-width: 920px)').matches) { countStyles(); return; }
          var fu = filterUrl();
          fu.searchParams.delete('page');
          refresh(fu.toString(), true);
        }
      });

      /* Number inputs only fire `change` on blur, so the price range needs
         `input` as well to keep the drawer's counters honest while typing. */
      root.addEventListener('input', function (e) {
        if (!e.target.closest('.toss-plpg__fprice')) return;
        syncPending();
        if (window.matchMedia('(max-width: 920px)').matches) countStyles();
      });

      /* Apply button in the drawer (and no-JS fallback form) */
      root.addEventListener('submit', function (e) {
        if (!e.target.closest('[data-plpg-filters]')) return;
        e.preventDefault();
        setDrawer(false);
        var u = filterUrl();
        u.searchParams.delete('page');
        refresh(u.toString(), true);
      });

      document.addEventListener('click', function (e) {
        var perpage = q('[data-plpg-perpage]');
        if (perpage && !perpage.contains(e.target)) closePerPage();
      });

      /* Back/forward restores the listing for that URL */
      window.addEventListener('popstate', function () {
        refresh(window.location.href, false);
      });

      unlockOutValues(root);
      if (drawerMq.addEventListener) {
        drawerMq.addEventListener('change', function () { unlockOutValues(root); });
      } else if (drawerMq.addListener) {
        drawerMq.addListener(function () { unlockOutValues(root); });
      }

      var saved = savedMult();
      if (saved > 1) applyMult(saved, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
